import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfigureComponent } from './pages/configure/configure.component';
import { CoreComponent } from './pages/core/core.component';
import { LandingComponent } from './pages/landing/landing.component';

const routes: Routes = [
	{ path: '', component: LandingComponent, canActivate: [] },
	{ path: 'configure', component: ConfigureComponent, canActivate: [] },
	{ path: 'core', component: CoreComponent, canActivate: [] },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
